import { render } from "./IndexStatistics.vue?vue&type=template&id=1f33f520&scoped=true&ts=true"
import script from "./IndexStatistics.vue?vue&type=script&lang=ts"
export * from "./IndexStatistics.vue?vue&type=script&lang=ts"

import "./IndexStatistics.vue?vue&type=style&index=0&id=1f33f520&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f33f520"]])

export default __exports__